const MarianIsland = () => {
  return (
    <svg
      width="19px"
      height="19px"
      viewBox="0 0 100 100"
      fill="var(--primary-90)"
      color="var(--primary-90)"
      stroke="var(--primary-90)"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        width: "19px",
        height: "19px",
      }}
    >
      <g transform="matrix(1,0,0,1,8.54669,-4.345)">
        <path d="M84.51,7.61L79.17,11.61L78,13.44L74,15.67L67.92,19.67L64.43,15.55L62.48,21.39L57.7,31L58.23,35.49L56.62,39.61C56.62,39.61 53.54,45.9 54.21,46.8C54.88,47.7 57.9,51 57.9,51L61.59,50.37L65.48,54.37L67.63,48.79L63.74,43.24C64.688,42.793 65.551,42.184 66.29,41.44C66.69,40.73 67.9,38.92 67.9,38.92L70.45,38.92L75.45,43.75C75.45,43.75 77.87,45.9 78.45,45.9C79.03,45.9 79.12,42.9 79.12,42.9L80.86,36.27L76.35,36.27L74.35,31.27L75.83,27.15L79.18,27.15L82.78,26.15L82.78,22.33L81.57,16.59L84.19,15.97L86.13,17.67L87.36,15.67L87.36,11.67L84.51,7.61Z" />
      </g>
      <g transform="matrix(1.00026,0,0,1.00026,9.81312,0.123715)">
        <path d="M50.35,65L45.59,62.9L42.91,61.34L42,59.08L46.45,57C46.99,56.748 47.39,56.267 47.54,55.69C47.693,55.108 47.576,54.486 47.22,54L45.52,51.64L48.1,48.34C48.715,47.569 48.672,46.452 48,45.73L44.49,42.14C43.954,41.598 43.153,41.407 42.43,41.65L24,47.74C23.472,47.915 23.04,48.303 22.81,48.81L20.88,53C20.45,53.6 20.46,54.64 20.47,56.46L20.47,57.68L17.22,60.48C16.627,60.993 16.388,61.808 16.61,62.56L17.51,65.56C17.757,66.407 18.537,66.996 19.42,67L23.55,67C23.74,72.76 24.77,73.6 25.24,74C26.415,74.765 27.71,75.329 29.07,75.67L29.07,77.9C29.073,78.139 29.117,78.376 29.2,78.6L31.35,84.38C31.489,84.786 31.756,85.137 32.11,85.38L36.41,88.25C36.74,88.467 37.125,88.585 37.52,88.59C37.796,88.589 38.068,88.531 38.32,88.42C38.944,88.15 39.389,87.581 39.5,86.91L41.3,75.91L47.42,72.83C47.705,72.687 47.952,72.478 48.14,72.22L51.14,68.1C51.386,67.759 51.519,67.349 51.519,66.928C51.519,66.139 51.052,65.42 50.33,65.1L50.35,65Z" />
      </g>
      <path d="M25.378,84.308L23.25,83.1C22.894,82.819 22.453,82.668 22,82.67L18.36,82.67C17.764,82.671 17.199,82.939 16.82,83.4L14.679,84.234L12.776,85.297L9.88,86.885L5.213,89.485L2.279,97.349C2.514,98.219 9.651,96.7 10.552,96.701C10.765,96.697 14.198,94.855 14.403,94.792L19.29,92.62L23.65,92.07C24.519,91.96 25.219,91.293 25.37,90.43L26.02,86.68C26.16,85.965 25.937,84.775 25.378,84.308Z" />
    </svg>
  );
};

export default MarianIsland;
